import { SidebarWrapperProps } from './SidebarWrapper.types';
import { Header, HeaderWrapper, Line } from './styles';

export const SidebarWrapper = ({
  heading,
  children,
  titleWithLine = true,
}: SidebarWrapperProps) => {
  return (
    <div>
      <HeaderWrapper titleWithLine={titleWithLine}>
        <Header titleWithLine={titleWithLine}>{heading}</Header>
        <Line />
      </HeaderWrapper>
      {children}
    </div>
  );
};
